import { useRef, useState } from 'react';
import useIntersectionObserver from './useIntersectionObserver';

const Contact = () => {
  const form = useRef();
  const [ref, isInView] = useIntersectionObserver();
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);


  const sendEmail = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      const response = await fetch("https://formspree.io/f/meaqrjqw", {
        method: "POST",
        body: new FormData(form.current),
        headers: { Accept: "application/json" },
      });
      if (response.ok) {
        form.current.reset();
        setSent(true);
        setTimeout(() => setSent(false), 5000);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error('Failed to send:', err.message);
      setError("Failed to send. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div ref={ref} className={`section-wrap ${isInView ? 'show' : 'hidden'}`} id="contact">
      <div className="contact-grid">
        <div className="contact-left">
          <div className="contact-eye">Get in touch</div>
          <h2 className="contact-headline">
            Let's build<br /><em>something great.</em>
          </h2>
          <p className="contact-desc">
            Always open to new opportunities, collaborations, and interesting conversations about
            tech. Whether it's a job, freelance project, or just a chat — reach out.
          </p>
          <div className="contact-detail">
            <div className="contact-icon">📍</div>
            <span className="contact-detail-text">Metro Manila, Philippines</span>
          </div>
          <div className="contact-detail">
            <div className="contact-icon">🕐</div>
            <span className="contact-detail-text">UTC +08:00</span>
          </div>
          <div className="contact-detail">
            <div className="contact-icon">💼</div>
            <span className="contact-detail-text">Open to remote &amp; local roles</span>
          </div>
        </div>

        <div className="contact-form">
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">First Name</label>
                <input className="form-control" type="text" name="firstName" placeholder="Juan" required />
              </div>
              <div className="form-group">
                <label className="form-label">Last Name</label>
                <input className="form-control" type="text" name="lastName" placeholder="dela Cruz" required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-control" type="email" name="email" placeholder="you@example.com" required />
              </div>
              <div className="form-group">
                <label className="form-label">Subject</label>
                <input className="form-control" type="text" name="subject" placeholder="Collaboration" required />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Message</label>
              <textarea className="form-control" name="message" placeholder="Hey JM, I'd love to..." required />
            </div>
            <button type="submit" className={`form-submit${sending ? ' sending' : ''}`} disabled={sending || sent}>
              {
              error 
                ? error   
                :sent 
                  ? 'Message sent! 🎉' 
                  : sending 
                    ? 'Sending...' 
                    : 'Send Message →'
              }
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
